"use client";

import { DataTablePagination } from "@/components/data-table-pagination";
import { useDataTable } from "@/hooks/use-data-table";
import { DataTable } from "@/lib/data-table";
import { suppliersPath } from "@/routes";
import type { PagyMetadata, RansackFilters, Supplier } from "@/types";

import { columns } from "./columns";

interface SuppliersDataTableProps {
  suppliers: Supplier[];
  pagy: PagyMetadata;
  filters: RansackFilters;
}

export function SuppliersDataTable({
  suppliers,
  pagy,
  filters,
}: SuppliersDataTableProps) {
  // Use shared data table logic for common operations
  const {
    isLoading,
    handlePageChange,
    handleSortingChange,
    getSortingState,
  } = useDataTable({ filters, pagy, path: suppliersPath() });

  return (
    <div className="space-y-4">
      {/* DataTable */}
      <div className={isLoading ? "opacity-50" : ""}>
        <DataTable
          columns={columns}
          data={suppliers}
          sorting={getSortingState()}
          onSortingChange={handleSortingChange}
          manualSorting={true}
          manualPagination={true}
          pageCount={pagy.pages}
          pagination={false}
        />
      </div>

      {/* Server-side pagination */}
      <DataTablePagination
        pagy={pagy}
        isLoading={isLoading}
        onPageChange={handlePageChange}
        entityName="proveedores"
      />
    </div>
  );
}
